import React, { useState, useEffect } from 'react';
import portfolioAPI from '../services/portfolioAPI';
import './Navigation.css';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  const [totalVisitors, setTotalVisitors] = useState(0);
  const [showVisitors, setShowVisitors] = useState(false);
  const [isBlinking, setIsBlinking] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      
      const sections = ['hero', 'about', 'skills', 'projects', 'contact'];
      const scrollPosition = window.scrollY + 100;
      
      for (let section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetBottom = offsetTop + element.offsetHeight;
          
          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const stats = await portfolioAPI.getPortfolioStats();
        const visitors = Number(stats?.total_visitors);
        setTotalVisitors(Number.isFinite(visitors) ? visitors : 0);
      } catch (error) {
        console.error('Error fetching portfolio stats:', error);
      }
    };

    fetchStats();
  }, []);

  useEffect(() => {
    let flipTimerId;

    const cycleInterval = setInterval(() => {
      setIsBlinking(true);

      flipTimerId = window.setTimeout(() => {
        setShowVisitors((prev) => !prev);
        setIsBlinking(false);
      }, 260);
    }, 3000);

    return () => {
      clearInterval(cycleInterval);
      if (flipTimerId) {
        clearTimeout(flipTimerId);
      }
    };
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const formattedVisitors = new Intl.NumberFormat('en-IN').format(totalVisitors);

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-logo">
          <div
            className={`logo-flip-card ${showVisitors ? 'show-back' : ''} ${isBlinking ? 'blink' : ''}`}
            aria-label={showVisitors ? `Visitor count ${formattedVisitors}` : 'SK logo'}
          >
            <div className="logo-face logo-front">
              <span className="logo-text">SK</span>
            </div>
            <div className="logo-face logo-back">
              <span className="visitor-label">Visitors</span>
              <span className="visitor-count">{formattedVisitors}</span>
            </div>
            <span className="logo-eyelid" aria-hidden="true"></span>
          </div>
        </div>
        <ul className="nav-menu">
          <li>
            <button 
              className={activeSection === 'hero' ? 'active' : ''}
              onClick={() => scrollToSection('hero')}
            >
              Home
            </button>
          </li>
          <li>
            <button 
              className={activeSection === 'about' ? 'active' : ''}
              onClick={() => scrollToSection('about')}
            >
              About
            </button>
          </li>
          <li>
            <button 
              className={activeSection === 'skills' ? 'active' : ''}
              onClick={() => scrollToSection('skills')}
            >
              Skills
            </button>
          </li>
          <li>
            <button 
              className={activeSection === 'projects' ? 'active' : ''}
              onClick={() => scrollToSection('projects')}
            >
              Projects
            </button>
          </li>
          <li>
            <button 
              className={activeSection === 'contact' ? 'active' : ''}
              onClick={() => scrollToSection('contact')}
            >
              Contact
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;